import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCountdown } from "@/components/edition/category/hooks/useCountdown";
import { cn } from "@/lib/utils";
import { Typography } from "@bookips/sds";
const CountdownModule = (param)=>{
    let { text , targetDate , className  } = param;
    const timeRemaining = useCountdown(targetDate);
    const formatTime = (value)=>String(value).padStart(2, "0");
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("ml-auto flex h-[72px] w-full flex-col items-center gap-1 rounded-md bg-gray-900/75 p-2 backdrop-blur-xs", "max-sm:h-[50px] max-sm:gap-0 max-sm:p-1", className),
        children: [
            text && /*#__PURE__*/ _jsx(Typography, {
                variant: "body2",
                className: "text-inverse-secondary max-sm:typo-caption text-white",
                children: text
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-1 text-white max-sm:gap-0.5",
                children: [
                    /*#__PURE__*/ _jsx(TimeText, {
                        value: formatTime(timeRemaining.hours)
                    }),
                    /*#__PURE__*/ _jsx(TimeDot, {}),
                    /*#__PURE__*/ _jsx(TimeText, {
                        value: formatTime(timeRemaining.minutes)
                    }),
                    /*#__PURE__*/ _jsx(TimeDot, {}),
                    /*#__PURE__*/ _jsx(TimeText, {
                        value: formatTime(timeRemaining.seconds)
                    })
                ]
            })
        ]
    });
};
// 시간 구분 점 컴포넌트
const TimeDot = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex w-3 flex-col items-start pb-1 max-sm:w-2 max-sm:gap-0.5",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "-mb-1 flex h-3 w-3 items-center justify-center max-sm:h-2 max-sm:w-2",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "h-1 w-1 rounded-full bg-white max-sm:h-[2.67px] max-sm:w-[2.67px]"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "-mb-1 flex h-3 w-3 items-center justify-center max-sm:h-2 max-sm:w-2",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "h-1 w-1 rounded-full bg-white max-sm:h-[2.67px] max-sm:w-[2.67px]"
                })
            })
        ]
    });
};
const TimeText = (param)=>{
    let { value  } = param;
    return /*#__PURE__*/ _jsx(Typography, {
        variant: "h5",
        className: "max-sm:typo-subtitle1 text-white",
        children: value
    });
};
export default CountdownModule;
